<template>

<el-dialog title="收款" v-model="showView" class="mt-5"  :show-close="false"  :before-close="handleClose">

      
              <div class="flex items-baseline">
                  <div class="text-lg text-gray-700 ">收款金额</div>
                  <div class=" text-4xl pl-3">￥{{payAmount}}</div>
                   <div class="text-lg text-gray-700 pl-6">差额</div>
                  <div class=" text-2xl text-red-600 pl-3">￥{{payAmount-payedAmount}}</div>
              </div>

             <div>
              <p class=" text-gray-700 text-lg mt-6">收款方式</p>

               <div class="mt-3">
                   <el-button v-for="payment in paymentList" @click="openInput(payment.payment_id,payment.payment_name)">{{payment.payment_name}}</el-button>
                    <el-button @click="openInput('201','会员卡')">会员卡</el-button>
               </div>
             
            <div class="mt-3" style="height:5rem;">  

 <el-tag
    v-for="(tag,idx) in tags"
    :key="idx"
    class="mx-1"
    closable
        @close="closeTagFun(idx)"
    :type="info"
  >
    {{tag.payment_name}}￥{{tag.payment_amount}}
  </el-tag>
  
                
             </div>

             

             </div>

  <template #footer>

    <span class="dialog-footer flex justify-end items-center" >

   <el-button type="primary" @click="paymentConfirmEvent">确 定</el-button>
      <el-button @click="paymentCloseEvent">取 消</el-button>

    </span>

  </template>
</el-dialog>





<el-dialog v-model="showChildView" :title="childObj.payment_name"
    :show-close="false"  :before-close="handleClose" width="30%" top="30vh">
            
    
            <el-input-number v-model="childAmount" min="0" :max="maxChildAmount" :precision="2" size="small"   />
            &nbsp;
           <el-button @click="numShowFun" size="small"  >小键盘</el-button>
           
        
  
  <template #footer>

    <span class="dialog-footer flex justify-end items-center" >


  <el-button @click="scanCardShowFun" size="small" color="#E6A23C" style="color: white" v-if="childObj.payment_id=='201'">识别会员卡</el-button>
   <el-button @click="childConfirmFun" size="small" color="#E6A23C" style="color: white" v-else>确 定</el-button>
      <el-button @click="childCloseFun" size="small">取 消</el-button>

    </span>

  </template>
</el-dialog>


   <Keyboard :showView="showNumPage" @numCloseEvent="numCloseFun" @numConfirmEvent="numConfirmFun">

   </Keyboard>

      <ScanCard  :scanFieldID="scanFieldID" @receiveScanReslut="receiveScanReslutFun" @scanCardClose="scanCardCloseFun" :disScanTypeSwitch="true" :series="false" :fromw="3" :showView="showScanPage">

    </ScanCard>

      <CardPwd
    :showView="showPwdPage"
    @closeEvent="pwdCloseFun"
    @confirmEvent="pwdConfirmFun">

  </CardPwd>

</template>
<script>
import { onActivated, reactive, ref, toRefs, watch } from 'vue'
import {  ElMessage } from 'element-plus'
import {  getPayment } from '@/utils/pos.js'
import {  doConsume } from '@/utils/member.js'

import Keyboard from '../keyboard/index.vue'
import ScanCard from '../scanCard/index.vue'
import CardPwd from '../cardPwd/index.vue'
import md5 from 'js-md5'
export default {
  name: 'Payment',
  props: {
    showView:Boolean,
    payAmount:Number,
  },
   components: { ScanCard, Keyboard,CardPwd},
   
  setup (props, { emit }) {

 
    const handleClose = () => {}
    const paymentCloseEvent = () => {


      emit('paymentCloseEvent')
      
    }
    const paymentConfirmEvent = () => {

       if(parseFloat(payedAmount.value)!=parseFloat(props.payAmount)){
          ElMessage({
          showClose: true,
          message: '款项还未收齐',
          type: 'error'
        })
        return;
       }
      emit('paymentConfirmEvent',tagField.tags);
      
    }

    const payedAmount=ref(0);
  

    //收款方式
    const paymentSelField=reactive({
        paymentList:[],
        paymentMap:{},
        getRemote:()=>{
            getPayment((list) => {
      paymentSelField.paymentList = list
    
      for (let i = 0; i < list.length; i++) {
        paymentSelField.paymentMap[list[i].payment_id] = list[i]
      }
    })

        }
    })
    paymentSelField.getRemote();


    const tagField=reactive({
        tags:[],
       closeTagFun: (idx) => {
         
         payedAmount.value-=tagField.tags[idx].payment_amount;
        tagField.tags.splice(idx,1);

      }
    });

     

    const openInput = (payment_id,payment_name) => {
        childViewField.showChildView=true;
        childViewField.childObj={
          payment_id,payment_name
        }
        childViewField.maxChildAmount=props.payAmount-payedAmount.value;
       childViewField.childAmount=props.payAmount-payedAmount.value;

    }

     /** 小键盘 **/
    const keyNumField=reactive({
        showNumPage:false,
        numCloseFun:() => {
          keyNumField.showNumPage = false
        },
        numShowFun:()=>{
           keyNumField.showNumPage = true
        },
        numConfirmFun:(val) => {
     
          childViewField.childAmount = parseFloat(val)
      
        }
    });

    const childViewField=reactive({
        maxChildAmount:0,
        childAmount:0,
        childObj:{},
        showChildView:false,  
        childCloseFun:()=>{
          childViewField.showChildView=false;
        },
         childConfirmFun:()=>{
          if(parseFloat(payedAmount.value)==parseFloat(props.payAmount)){
   ElMessage({
          showClose: true,
          message: '款项已收齐',
          type: 'error'
        })
            return;
          } 
          childViewField.showChildView=false;
          if(parseFloat(childViewField.childAmount)>0){

            tagField.tags.push({
               payment_id:childViewField.childObj.payment_id,
               payment_name:childViewField.childObj.payment_name,
               payment_amount:childViewField.childAmount,
               payment_attach:''
            });
                 payedAmount.value+=childViewField.childAmount;
           
          }else{
             ElMessage({
          showClose: true,
          message: '收款金额不能为0',
          type: 'error'
        })

          }
        }
    });
  
    const scanField=reactive({
        card:{},
        scanFieldID:'scanFieldIDChild',
        showScanPage:false,
        receiveScanReslutFun:(cardParam) => {
            scanField.card=cardParam;
            prefixDeductFun("");
       },
       scanCardCloseFun:() => {
    
            scanField.showScanPage = false
        },
        scanCardShowFun:()=>{
               scanField.showScanPage = true
        }
    });

const prefixDeductFun=(pwd)=>{
 if(parseFloat(childViewField.childAmount)<0){

         
             ElMessage({
          showClose: true,
          message: '收款金额不能为0',
          type: 'error'
        })
        return;
  }
  if(parseFloat(payedAmount.value)==parseFloat(props.payAmount)){
   ElMessage({
          showClose: true,
          message: '款项已收齐',
          type: 'error'
        })
            return;
  } 
  doConsume({
      amount_val:childViewField.childAmount,
      card_id:scanField.card.card_id,
      pwd: pwd != '' ? md5(pwd) : ''
  },(res)=>{
           childViewField.showChildView=false;
          tagField.tags.push({
               payment_id:childViewField.childObj.payment_id,
               payment_name:'会员卡',
               payment_amount:childViewField.childAmount,
               payment_attach:res.bill_id
            });
            payedAmount.value+=childViewField.childAmount;

  }, (error) => {
        if (error.code == -799010) {
          pwdField.showPwdPage = true
        }
  });
};


const pwdField = reactive({
      showPwdPage: false,
      pwdCloseFun: () => {
        pwdField.showPwdPage = false
      },
      pwdConfirmFun: (val) => {
        pwdField.showPwdPage = false
         prefixDeductFun(val)
      }

    })



   
    
    return {
      handleClose, paymentCloseEvent, paymentConfirmEvent,...toRefs(tagField),openInput,
      ...toRefs(paymentSelField),...toRefs(keyNumField),...toRefs(childViewField),payedAmount,
      ...toRefs(scanField),...toRefs(pwdField)
    }
  }
}
</script>

